import Seo from "@/components/Seo";
import { FadeIn, Eyebrow } from "@/components/Reveal";

const SECTIONS = [
    {
        title: "1. Quem somos",
        text: "Contabeleza, assessoria contábil especializada no mercado da beleza. Esta Política descreve como tratamos dados pessoais em nosso site, em conformidade com a Lei Geral de Proteção de Dados (LGPD, Lei nº 13.709/2018).",
    },
    {
        title: "2. Quais dados coletamos",
        text: "Ao preencher nosso formulário de diagnóstico, coletamos: nome, telefone/WhatsApp, e-mail, nome do estabelecimento, tipo de negócio, quantidade de profissionais e, opcionalmente, uma mensagem livre. Também registramos parâmetros de origem da visita (UTMs) para entender como você chegou até nós.",
    },
    {
        title: "3. Para que usamos",
        text: "Os dados são usados exclusivamente para: retornar o seu contato, realizar o diagnóstico gratuito solicitado, apresentar propostas de serviços da Contabeleza e melhorar nossa comunicação. Não vendemos nem compartilhamos seus dados com terceiros para fins de marketing.",
    },
    {
        title: "4. Base legal",
        text: "O tratamento se fundamenta no consentimento do titular (art. 7º, I, da LGPD), coletado no momento do envio do formulário, e no legítimo interesse (art. 7º, IX) para métricas de navegação anonimizadas.",
    },
    {
        title: "5. Cookies e ferramentas de medição",
        text: "Utilizamos cookies essenciais ao funcionamento do site e, mediante o seu consentimento no banner de privacidade, ferramentas de análise e publicidade (Google Analytics 4, Google Tag Manager e Meta Pixel). Você pode recusar os cookies não essenciais a qualquer momento, sem prejuízo à navegação.",
    },
    {
        title: "6. Compartilhamento",
        text: "Seus dados podem ser acessados por nossa equipe comercial e por ferramentas de gestão de relacionamento (CRM) contratadas pela Contabeleza, sempre sob obrigação de confidencialidade e apenas para as finalidades descritas nesta Política.",
    },
    {
        title: "7. Armazenamento e segurança",
        text: "Os dados ficam armazenados em ambiente seguro, com acesso restrito, pelo tempo necessário para cumprir as finalidades desta Política ou obrigações legais aplicáveis.",
    },
    {
        title: "8. Seus direitos",
        text: "Você pode, a qualquer momento, solicitar confirmação, acesso, correção, anonimização, portabilidade ou eliminação dos seus dados pessoais, além de revogar o consentimento. Para exercer seus direitos, fale conosco pelo WhatsApp disponível no site.",
    },
    {
        title: "9. Alterações desta Política",
        text: "Esta Política pode ser atualizada para refletir melhorias ou exigências legais. A versão vigente estará sempre disponível nesta página, com a data da última revisão.",
    },
];

export default function PrivacyPolicyPage() {
    return (
        <>
            <Seo
                title="Política de Privacidade, Contabeleza | LGPD"
                description="Política de Privacidade da Contabeleza em conformidade com a LGPD (Lei nº 13.709/2018): coleta, uso, cookies, direitos dos titulares e contato."
            />

            <section className="grain relative overflow-hidden bg-[#08104F] px-5 pb-16 pt-32 sm:px-8 sm:pt-40">
                <div className="pointer-events-none absolute inset-0 hero-grid-lines" />
                <div className="relative mx-auto max-w-4xl">
                    <FadeIn y={16}>
                        <Eyebrow light>LGPD, Lei nº 13.709/2018</Eyebrow>
                    </FadeIn>
                    <h1 className="mt-5 font-display text-4xl leading-[1.08] tracking-tight text-[#F3EDE6] sm:text-5xl">
                        Política de Privacidade
                    </h1>
                    <FadeIn delay={0.3}>
                        <p className="mt-5 max-w-xl text-base leading-relaxed text-[#B2D0FF]">
                            Transparência radical é um dos nossos valores. Aqui está, sem juridiquês, como
                            cuidamos dos seus dados.
                        </p>
                    </FadeIn>
                </div>
            </section>

            <section className="px-5 py-16 sm:px-8 sm:py-24">
                <div className="mx-auto max-w-4xl space-y-6">
                    {SECTIONS.map((section, i) => (
                        <FadeIn key={section.title} delay={Math.min(i * 0.04, 0.2)}>
                            <article className="rounded-2xl border border-[#08104F]/8 bg-[#FFFDFA] p-7">
                                <h2 className="font-display text-lg text-[#08104F]">{section.title}</h2>
                                <p className="mt-3 text-sm leading-relaxed text-[#3A4768]">{section.text}</p>
                            </article>
                        </FadeIn>
                    ))}
                    <p className="pt-4 text-center text-xs text-[#3A4768]/60">
                        Última atualização: julho de 2026.
                    </p>
                </div>
            </section>
        </>
    );
}
